import { Route, Routes } from 'react-router-dom';
import { useAuthentication } from '../auth';
import { NotFound } from '../NotFound';
import { hasInternalAccess } from '../util/auth';
import { InternalDashboard } from './views/InternalDashboard';

export const Internal = () => {
  const currentUser = useAuthentication();

  if (!hasInternalAccess(currentUser)) {
    return <NotFound />;
  }

  return (
    <Routes>
      <Route index element={<InternalDashboard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
